import * as React from 'react';
import { Transition } from 'react-spring/renderprops.cjs';

import { ModalWrap, CustomModalInner } from './Elements';
import { StyledSystemProps } from '../../theme/StyledSystemProps';

const MODAL_ANIM_CONFIG = {
  duration: 250,
  tension: 100,
  friction: 10,
};

type ModalProps = StyledSystemProps & {
  onClose: () => null;
  children: React.ReactNode;
  open: boolean;
};

const CustomModal: React.FC<ModalProps> = ({ children, open }) => (
  <Transition
    items={open}
    native={true}
    config={MODAL_ANIM_CONFIG}
    from={{
      opacity: 0,
      transform: 'translateY(40px)',
    }}
    enter={{
      opacity: 1,
      transform: 'translateY(0)',
    }}
    leave={{
      opacity: 0,
      transform: 'translateY(40px)',
      pointerEvents: 'none',
    }}
  >
    {modalOpen =>
      modalOpen &&
      (props => (
        <ModalWrap style={{ opacity: props.opacity }}>
          <CustomModalInner>{children}</CustomModalInner>
        </ModalWrap>
      ))
    }
  </Transition>
);

export default CustomModal;



// WEBPACK FOOTER //
// ./src/components/modal/CustomModal.tsx